module.exports = __webpack_public_path__ + "static/media/Jennifer E.ef985e10.png";